export const version = 'kunde-v1.15.0-SNAPSHOT-e45961e94ba9b5e8f4d782b3c20624a88e212743';